<template>
  <b-tab title="Create List" active>
    <div class="card card-tabtop card-ornament upload-list">
      <h2>Add a recipient</h2>
      <p>You can enter recipient's information below. The system will check and flag duplicate entries for review.</p>
      <family-form :submission-handler="addFamilySubmissionHandler" :cancel-text="'Clear Name'" submit-text="'Add Name'" />
    </div>
  </b-tab>
</template>

<script>
import FamilyForm from './FamilyForm';

export default {
  name: 'CreateFamilyTab',
  components: { FamilyForm,},
  methods: {
    addFamilySubmissionHandler(value, cb) {
      // TODO: Validation could go here

      console.log('Submitted', value);
      const recip = {
        ...value,
        organization: this.$store.getters.getUserOrg,
      };
      const payload = {
        vm: this,
        recips: [recip],
        cb,
      };
      this.$store.dispatch('checkRecipient', payload);
    }
  }
}
</script>
